// Import slick css files
import '../../styles/componentStyles/slick.scss';
import '../../styles/componentStyles/slick-theme.scss';

import Divider from '../Atoms/Divider';
import Card from '../Molecules/Card';
import TextBox from '../Atoms/TextBox';
import React, { useState, Component } from 'react';
import Slider from "react-slick";
import { client } from '../../client';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';





      
function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  // console.log("className: " + className); == // slick-arrow slick-next
  return (
    <div

      className={className}
      style={{ display: "flex",  background: "#fff", borderLeft: "1px solid blue", borderBottom: "1px solid blue", flexWrap: "wrap", justifyContent: "center", overflow: "hidden"}}
      onClick={onClick}
    >
    
    <p className="slick-label" style={{ color: "blue", display: "flex", paddingRight: "10px"  }}> NÆSTE <span style={{ width: "60px" }}></span></p>
    {/* , position: "absolute", bottom: "10px" */}
    </div>
  );  
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ display: "flex", background: "#fff", borderRight: "1px solid blue", borderBottom: "1px solid blue", flexWrap: "wrap", justifyContent: "center", overflow: "hidden"}}
      onClick={onClick}
    >
    
    <p className="slick-label" style={{ color: "blur", display: "flex", paddingRight: "10px"  }}> TILBAGE<span style={{ width: "60px" }}></span></p>
    
    </div>
  );
}

class CardSlider extends Component {
  // use a constructor if necessary
  constructor(props) {
    super(props);

    this.state = {
      cardData: []
      // title: [],
      // titleEnglish: '',
      // exhibitionPlace: '',
      // year: ''
    }  

  }

  //this is where we receive API calls inside components
  componentDidMount() {
    client.getEntries({
      content_type: "workItem",
      order: '-fields.year'
    })
      .then((response) => {
        this.setState({
          cardData : response.items
        })
        // console.log(`${response.items[0].fields.thumbnail.fields.file.url}?w=100&h=100`)
    })
    
      // .then((data) => {
      //   console.log(this.state.cardData)
      //   getEntries({'metadata.tags.sys.id[all]': 'tagOne,tagTwo'}))
      
      //   })

    
    .catch(console.error)
  }
  
 

  render() {
    var settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 3,
      arrows: true,
      adaptiveHeight: true,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
      responsive: [
        {
          breakpoint: 450,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 200,
            centerMode: false,
            infinite: true,
            centerMode: true,
            adaptiveHeight: true,
            arrows: false
            // variableWidth: false,
            // centerPadding: '0px'
            
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 200,
            centerMode: false,
            infinite: true,
            centerMode: true,
            adaptiveHeight: true,
            // variableWidth: false,
            // centerPadding: '0px'
            
          }
        }
        
      ]
    };

  
    // console.log(this.state.cardData)

    // console.log(this.state.items.items)
    return (
          <Slider {...settings}>
            
              
              {this.state.cardData.map((singleCardData, index) => (
                <Card data={singleCardData} key={index} cx="br bb phone-b0" chipLink="/filter/vaerker"/>
              )
              
              )}
              
        </Slider>

    );
  }
}



export default CardSlider;



